export enum ErrorCode {
	currencyConversionFailed = 'currency-conversion-failed',
}
